import axios from "axios";
import { serverURL, serverDjangoURL } from "variables/ServerURL";

const publicAxios = axios.create({
  baseURL: serverDjangoURL,
});

export default publicAxios;
